import { render } from "./modalChangePassword.vue?vue&type=template&id=923d144e"
import script from "./modalChangePassword.vue?vue&type=script&lang=js"
export * from "./modalChangePassword.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__